<template>
<div>
    <section v-if="product" class="text-gray-700 body-font overflow-hidden bg-white">
        <section class="font-mono bg-white container mx-auto px-5 flex flex-col lg:flex-row">
            <div class="w-full flex flex-col items-center py-8 lg:w-1/3">
                <img class="rounded-sm" :src="product.media.source" />
            </div>
            <div class="w-full flex flex-col items-center py-8 lg:w-2/3">
                <div class="flex flex-col w-full mb-12 text-left">
                    <div class="w-full mx-auto lg:w-1/2">
                        <h1 class="mx-auto mb-6 text-2xl font-semibold text-black lg:text-3xl">{{product.name}}</h1>
                        <p class="mx-auto text-base font-medium leading-relaxed text-gray-800" v-html="product.description"></p>

                        <!-- <div class="flex">
                            <span class="mr-3">Color</span>
                            <button class="border-2 border-gray-300 rounded-full w-6 h-6 focus:outline-none"></button>
                            <button class="border-2 border-gray-300 ml-1 bg-gray-700 rounded-full w-6 h-6 focus:outline-none"></button>
                            <button class="border-2 border-gray-300 ml-1 bg-red-500 rounded-full w-6 h-6 focus:outline-none"></button>
                        </div> -->
                        <div class="flex ml-6" v-if="product.variants.length">
                            <span class="mr-3">Size</span>
                            <div class="relative">
                                {{product.variants[0].optionsById[sizeSelect] &&  product.variants[0].optionsById[sizeSelect].name}}
                                <select class="rounded border appearance-none border-gray-400 py-2 focus:outline-none focus:border-red-500 text-base pl-3 pr-10" v-model="sizeSelect" name='sizeSelect'>
                                    <option value="" disabled>Choose a size</option>
                                    <option v-for="option of product.variants[0].options" :value="option.id" :key="option.id">
                                        {{option.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 mt-4 bg-white border rounded-lg w-full mx-auto lg:w-1/2">
                        <div class="flex py-2 mb-4 w-full">
                            <p class="text-sm font-semibold tracking-tight text-black">{{product.price.formatted_with_code}}</p>
                        </div>
                        <button v-if="product.variants.length" :disabled="!!!sizeSelect" @click="addProductToCart" name="addToCartButton" class="inline-block bg-yellow-500 hover:bg-yellow-600 hover:bg-yellow-700 focus-within:ring ring-yellow-300 text-white text-sm md:text-base font-semibold text-center rounded-lg outline-none transition duration-100 px-8 py-3">Add to cart</button>
                        <button v-else @click="addProductToCart" name="addToCartButton" class="inline-block bg-yellow-500 hover:bg-yellow-600 hover:bg-yellow-700 focus-within:ring ring-yellow-300 text-white text-sm md:text-base font-semibold text-center rounded-lg outline-none transition duration-100 px-8 py-3">Add to cart</button>
                    </div>
                </div>
            </div>
        </section>
    </section>
    <p v-else>
        Loading Product
    </p>
    <!-- component -->
</div>
</template>

<script>
import Label from './Label'
export default {
    name: 'ProductDetail',
    props: ['product'],
    components: {
        Label,
    },
    methods: {
        addProductToCart() {
            const product = {
                productId: this.product.id,
                variant: !this.product.variants.length || {
                    [this.product.variants[0].id]: this.sizeSelect
                }
            }
            this.$emit('add-product-to-cart', product)
        }
    },
    data() {
        return {
            sizeSelect: ''
        }
    }
}
</script>
